export default __webpack_public_path__ + "static/media/recent-transaction-icon.64b72846.png";